import { StyleSheet, View } from 'react-native';
import { Text } from '@/components/common/AppText';
import { JourneyIcon } from './journey-icons';
import { TEXT_START, useJourneyPalette } from './journey-theme';

/**
 * Checked feature list (`.included-list`). `tone`: `included` (green check),
 * `brand` (violet check, plan rows / offer), `stops` (grey cross).
 */
export function BenefitList({
  items,
  tone = 'included',
  size = 'regular',
}: {
  items: readonly string[];
  tone?: 'included' | 'brand' | 'stops';
  size?: 'regular' | 'compact';
}) {
  const palette = useJourneyPalette();
  const color =
    tone === 'brand' ? palette.brand : tone === 'stops' ? palette.secondary : palette.green;
  const compact = size === 'compact';
  return (
    <View style={[styles.list, compact && styles.compactList]}>
      {items.map((item) => (
        <View key={item} style={styles.item}>
          <View style={styles.icon}>
            <JourneyIcon
              name={tone === 'stops' ? 'close' : 'check'}
              size={compact ? 14 : 16}
              color={color}
            />
          </View>
          <Text
            style={[
              compact ? styles.compactText : styles.text,
              { color: palette.text },
              TEXT_START,
            ]}
          >
            {item}
          </Text>
        </View>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  list: { gap: 10, marginVertical: 12 },
  compactList: { gap: 6, marginVertical: 0 },
  item: { flexDirection: 'row', alignItems: 'flex-start', gap: 9 },
  icon: { marginTop: 2 },
  text: { flex: 1, fontSize: 14, lineHeight: 20 },
  compactText: { flex: 1, fontSize: 13, lineHeight: 18 },
});
